import { REACT_APP_ONLINE_LESSON_TEACHER_URL } from '../configs';

type routeHelper = {
  path: string;
  open: () => void;
  replace: () => void;
};
/**
 * レッスン画面遷移
 * @param companyId
 * @param roomId
 * @returns
 */
export const routeJoinLessonPreview = (companyId: string, roomId: string) => {
  const params = new URLSearchParams({
    lang: 'ja',
  });
  const path = new URL(
    `/preview/${companyId}/${roomId}/?${params}`,
    REACT_APP_ONLINE_LESSON_TEACHER_URL,
  ).href;
  return {
    path,
    //   FIXME 他と合わせてwindowでの遷移、react-routerの機能を使うように変更する場合は、Hooksに変更
    open: () => {
      window.open(path, '_blank');
    },
    replace: () => {
      window.location.replace(path);
    },
  };
};
export const routeJoinLessonVideo = (): routeHelper => {
  const path = `/join-lesson/video/`;
  return {
    path,
    //   FIXME 他と合わせてwindowでの遷移、react-routerの機能を使うように変更する場合は、Hooksに変更
    open: () => {
      window.open(path, '_blank');
    },
    replace: () => {
      window.location.replace(path);
    },
  };
};
